export default "__VITE_ASSET__CjaLKlJP__"